<template>
  <screening-workflow-panel
    :review="review"
    :current-researcher="currentResearcher"
    :pending-connection.sync="referencesVotedOnConnection"
    :pending-connection-query="
      $apollo.queries.referencesVotedOnConnection
    "
    :search-input.sync="searchInput"
    :get-vote-by-current-user-func="getVote"
    :revoke-vote-func="revokeVote"
    :filtering-input="filteringInput"
    :should-hide-reference-func="shouldHideReference"
    :should-hide-reference-based-on-vote-func="doNothing"
    disable-select-next-on-vote
    hide-on-undo
    restrict-to-voting-only
    full-text-review
    @clear-filtering-input="$emit('clear-filtering-input')"
  >
    <template #empty-state>
      <screen-tab-complete-empty-state />
    </template>
  </screening-workflow-panel>
</template>

<script>
import ScreenTabCompleteEmptyState from '@/components/ScreeningPageV2/ScreenTab/ScreenTabCompleteEmptyState';
import ScreeningWorkflowPanel from '@/components/ScreeningPageV2/ScreenTab/ScreeningWorkflowPanel';
import { GetReferencesByFullTextReviewVoteHistory } from '@/graphql';
import {
  Review,
  Researcher,
  ReferenceOffsetConnection,
  ReferenceFilteringInputDto,
} from '@/models';
import { isEqual } from 'lodash';
import { mapActions } from 'vuex';

const PAGE_SIZE = 50;

export default {
  name: 'ReviewTabYourVotes',
  components: {
    ScreenTabCompleteEmptyState,
    ScreeningWorkflowPanel,
  },
  props: {
    review: {
      type: Review,
      required: true,
    },
    currentResearcher: {
      type: Researcher,
      required: true,
    },
    filteringInput: {
      type: ReferenceFilteringInputDto,
      required: true,
    },
    active: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['clear-filtering-input'],
  data: () => ({
    searchInput: null,
    referencesVotedOnConnection: null,
    hiddenReferenceMap: {},
    doNothing: () => {},
  }),
  apollo: {
    referencesVotedOnConnection: {
      query: GetReferencesByFullTextReviewVoteHistory,
      variables() {
        return {
          reviewId: this.review.id,
          limit: PAGE_SIZE,
          searchQuery: this.searchInput || null,
          hasTag: this.filteringInput.hasTag,
          hasKeyword: this.filteringInput.hasKeyword,
          hasAuthor: this.filteringInput.hasAuthor,
          hasPlacePublished: this.filteringInput.hasPlacePublished,
        };
      },
      update: (data) => {
        return new ReferenceOffsetConnection(
          data.referencesByFullTextReviewVoteHistory
        );
      },
      skip() {
        return !this.review?.id;
      },
      fetchPolicy: 'cache-and-network',
      notifyOnNetworkStatusChange: true,
    },
  },
  watch: {
    active(active) {
      if (active && this.referencesVotedOnConnection) {
        this.$apollo.queries.referencesVotedOnConnection.refetch();
      }
    },
    filteringInput(newInput, oldInput) {
      // Clear the cache when the filtering input changes to show the loading state.
      const changed = !isEqual(newInput, oldInput);
      if (this.active && changed) {
        this.referencesVotedOnConnection = null;
      }
    },
  },
  methods: {
    ...mapActions({
      revokeVote: 'fullTextReviewVote/deleteWithCacheUpdate',
    }),
    getVote(reference) {
      return reference?.getFullTextReviewVoteBy(
        this.currentResearcher
      );
    },
    shouldHideReference(reference) {
      return !reference.getFullTextReviewVoteBy(
        this.currentResearcher
      );
    },
  },
};
</script>
